<template>
  <div class="contact-container" data-aos="fade-up">
    <!-- 欢迎文案 -->
    <div class="welcome-section" data-aos="fade-down" data-aos-delay="200">
      <h1>欢迎联系我们</h1>
      <p class="welcome-text">
        我们非常期待与您建立联系，并愿意为您提供更多的信息和服务。
        如果您有任何问题或建议，请随时通过以下方式与我们取得联系。
      </p>
      <el-button type="primary" @click="_goContact" class="contact-button">
        留下联系方式
      </el-button>
    </div>

    <!-- 联系信息 -->
    <div class="contact-info-section" data-aos="fade-up" data-aos-delay="300">
      <h2 class="section-title">我们的联系方式</h2>
      <div class="info-grid">
        <div class="info-card" data-aos="zoom-in" data-aos-delay="400">
          <div class="info-icon">
            <i class="el-icon-location-information"></i>
          </div>
          <h3>地址</h3>
          <p>河南省鹤壁市淇滨区金融大厦702</p>
        </div>
        <div class="info-card" data-aos="zoom-in" data-aos-delay="500">
          <div class="info-icon">
            <i class="el-icon-phone-outline"></i>
          </div>
          <h3>电话</h3>
          <p>13403922611</p>
        </div>
        <div class="info-card" data-aos="zoom-in" data-aos-delay="600">
          <div class="info-icon">
            <i class="el-icon-message"></i>
          </div>
          <h3>邮箱</h3>
          <p>397626534@qq.com</p>
        </div>
        <div class="info-card" data-aos="zoom-in" data-aos-delay="700">
          <div class="info-icon">
            <i class="el-icon-time"></i>
          </div>
          <h3>工作时间</h3>
          <p>周一至周六: 8:30 - 17:30</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  methods: {
    scrollToContact() {
      // 平滑滚动到联系信息区域
      const contactSection = document.querySelector(".contact-info-section");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    // 初始化AOS动画
    import("aos").then((AOS) => {
      AOS.init({
        duration: 600,
        once: true,
      });
    });
  },
};
</script>

<style scoped>
.contact-container {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.welcome-section {
  text-align: center;
  padding: 60px 0;
}

.welcome-section h1 {
  font-size: 36px;
  margin-bottom: 15px;
  color: #333;
}

.welcome-text {
  font-size: 18px;
  color: #666;
  max-width: 800px;
  margin: 0 auto 30px;
}

.contact-button {
  background-color: #f97d01;
  border-color: #f97d01;
  padding: 12px 24px;
  font-size: 16px;
  transition: all 0.3s;
}

.contact-button:hover {
  background-color: #ff9a3d;
  border-color: #ff9a3d;
}

.section-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
  color: #333;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
}

.info-card {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.info-icon {
  font-size: 40px;
  color: #f97d01;
  margin-bottom: 20px;
}

.info-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.info-card p {
  color: #666;
  font-size: 14px;
}

@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
  }

  .welcome-section h1 {
    font-size: 28px;
  }

  .welcome-text {
    font-size: 16px;
  }
}
</style>
